export { default as Login_3 } from './login-3.png';
